// src/components/Auth/AuthModal.tsx
import React from 'react'
import { useAuthModal } from '@/contexts/AuthModalContext'
import { LoginModal } from './LoginModal'
import { SignupModal } from './SignupModal'
import { ForgotPasswordModal } from './ForgotPasswordModal'

export const AuthModal: React.FC = () => {
  const { mode } = useAuthModal()

  if (mode === 'login') {
    return <LoginModal />
  }

  if (mode === 'signup') {
    return <SignupModal />
  }

  if (mode === 'forgot-password') return <ForgotPasswordModal />

  return null
}
